import { defineComponent as _defineComponent } from 'vue'
import AddToCartSidebar from 'JS/components/side-menus/add-to-cart/AddToCartSidebar.vue';
import bugsnagClient from 'JS/global/bugsnag';
import ChangeStoreSideMenu from 'JS/components/side-menus/change-store/ChangeStoreSideMenu.vue';
import Icon from 'JS/components/Icon.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import ManageSubscriptionSideMenu from './ManageSubscriptionSideMenu.vue';
import Price from 'JS/components/price/Price.vue';
import SubscriptionService from 'JS/services/SubscriptionService';
import UiButton from 'JS/components/UiButton.vue';
import { AddToCartResult, MaxLinesExceededResponse } from 'JS/services/ProductService';
import { computed, ref, watch } from 'vue';
import { format } from 'date-fns';
import { ILocalStoreJson } from "JS/types/LocalStore";
import { SubscriptionOverview } from 'JS/types/subscription';


export default /*#__PURE__*/_defineComponent({
  __name: 'Subscription',
  props: {
    subscription: null,
    localStore: null,
    changedValues: null
  },
  emits: ["showHideLoader", "showHideError", "refresh", "updated-subscription"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'showHideLoader', show: boolean): void;
	(e: 'showHideError', show: boolean): void;
	(e: 'refresh'): void;
	(e: 'updated-subscription', update: {id: number, values: string[]}) : void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	subscription: SubscriptionOverview;
	localStore: ILocalStoreJson;
	changedValues?: string[];
}




const _subscriptionService = new SubscriptionService();
const showManageSub = ref<boolean>(false);
const maxLineItemsModal = ref<MaxLinesExceededResponse>(null);
const showChangeStore = ref<boolean>(false);

const frequencyString = computed(() => props.subscription.frequency > 1 ? "Every " + props.subscription.frequency + " weeks" : "Every week");

const changeValMessage = computed(()=> {
	if (!props.changedValues?.length) return "";

	if (props.changedValues.length === 3) {
		return 'Your subscription <strong>quantity, frequency</strong> and <strong>order confirmation date</strong> have been updated.';
	} else if (props.changedValues.length === 2) {
		return 'Your subscription <strong>' + props.changedValues[0] + '</strong> and <strong>' + props.changedValues[1] + '</strong> have been updated';
	} else {
		return 'Your subscription <strong>' + props.changedValues[0] + '</strong> has been updated';
	}
});

const notEnough = computed(() => {
	return props.subscription.quantity > props.subscription.product.storeEcomOnHand;
});

const lowStock = computed(() => {
	return notEnough.value && props.subscription.product.storeEcomOnHand > 0;
});

const noStock = computed(() => {
	return props.subscription.product.notCarriedInStore || props.subscription.product.storeEcomOnHand <= 0;
});

const stockMessage = computed(() => {
	if (props.subscription.product.notCarriedInStore) {
		return 'Not Carried';
	} else if (props.subscription.product.storeEcomOnHand <= 0) {
		return 'Out of stock';
	} else if (lowStock.value) {
		return `Only ${props.subscription.product.storeEcomOnHand} available`;
	} else return 'In Stock';
});

function toggleManageSubSideMenu(changesMade: boolean = false) {
	showManageSub.value = !showManageSub.value;
	if (changesMade == true) {
		emit('refresh');
	}
}

function handleChangedValues(changedVals: string[]) {
	emit('updated-subscription', { id: props.subscription.id, values: changedVals });
	showManageSub.value = false;
}

function closeMaxLineModal() {
	maxLineItemsModal.value = null;
}

function goToCart() {
	window.location.href = '/cart/';
}

async function orderSubscriptionProduct() { //Buy Now
	emit('showHideLoader', true);
	emit('showHideError', false);
	try {
		const addToCartResponse = await _subscriptionService.orderSubscriptionProduct(props.subscription.id);
		if (addToCartResponse.result == AddToCartResult.Success) {
			goToCart();
		} else {
			if (addToCartResponse.result == AddToCartResult.MaxLines) {
				maxLineItemsModal.value = { 
					result: AddToCartResult.MaxLines,
					errorMessage: addToCartResponse.errorMessage
				 };
			} else {
				emit('showHideError', true);
			}
			emit('showHideLoader', false);
		}
	} catch (e) {
		emit('showHideError', true);
		bugsnagClient.notify(e);
		emit('showHideLoader', false);
	}
}

const changedValueMessageKey = ref<number>();
watch(()=> props.changedValues, (changedVals) => {
	changedValueMessageKey.value = Date.now();
});


return { __sfc: true,props, emit, _subscriptionService, showManageSub, maxLineItemsModal, showChangeStore, frequencyString, changeValMessage, notEnough, lowStock, noStock, stockMessage, toggleManageSubSideMenu, handleChangedValues, closeMaxLineModal, goToCart, orderSubscriptionProduct, changedValueMessageKey, AddToCartSidebar, ChangeStoreSideMenu, Icon, LinkButton, ManageSubscriptionSideMenu, Price, UiButton, format }
}

})